var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:trellicons;src:url(" + escape(require("fonts/trellicons.eot")) + "?#iefix) format(\"embedded-opentype\"),url(" + escape(require("fonts/trellicons.woff")) + ") format(\"woff\"),url(" + escape(require("fonts/trellicons.ttf")) + ") format(\"truetype\");font-weight:400;font-style:normal}._2O4TvNuF7v0hxu{color:#798d99;display:inline-block;font-family:trellicons;font-size:12px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-style:normal;font-weight:400;line-height:1;text-align:center;text-decoration:none;box-shadow:none}._2KEwvRY1oTHWsQ{height:32px;font-size:16px;line-height:32px;width:32px}.PFt09HVBG7wMY9{height:20px;font-size:12px;line-height:20px;width:20px}.Ti1qtx843DNeij:before{content:\"\\E968\"}._2p2TP4mBgXTJP3:before{content:\"\\E967\"}._1lRR-WGFaAL7Rg:before{content:\"\\E966\"}.sVIW73wwiyo-ks:before{content:\"\\E965\"}._1OryvMSh-C4bWl:before{content:\"\\E964\"}._1de3r8WsF7Yh8K:before{content:\"\\E963\"}._3i67k-gVumomHu:before{content:\"\\E962\"}._31TAf4mRgtkVX1:before{content:\"\\E961\"}._2RhErfMv_mzFHP:before{content:\"\\E960\"}._2H2bc6x5IUre2M:before{content:\"\\E95F\"}._3dQefSBi-fAz7d:before{content:\"\\E95E\"}.XJAu7LvbAvjSOO:before{content:\"\\E95D\"}._2X44dse6n-cQsb:before{content:\"\\E95C\"}.AWpfRMKS6EXBgD:before{content:\"\\E95B\"}._2Vf6cuxKtYocO6:before{content:\"\\E95A\"}.bwL1OKx7tRehy-:before{content:\"\\E959\"}._3aNdzOPsziq37o:before{content:\"\\E958\"}._3jWf4yaZ1WbIbz:before{content:\"\\E957\"}.GOq5Er_TVbEM3t:before{content:\"\\E956\"}._3bSwJmXnSoGyIF:before{content:\"\\E955\"}._1ecbMWhcUXKTSA:before{content:\"\\E954\"}._2aGFP06p1cMlIx:before{content:\"\\E953\"}._2gw3dyIjIZ9sq2:before{content:\"\\E952\"}._13OvihIH2x9qPC:before{content:\"\\E951\"}.w7LPN0RMWIlifw:before{content:\"\\E900\"}._2LDR5G_PpSxWfb:before{content:\"\\E950\"}.Amzy_Uos05KXvv:before{content:\"\\E969\"}.kj9GoITAoCRkdj:before{content:\"\\E94F\"}._1iYaKo0RX8H9ru:before{content:\"\\E94E\"}._1fL5z3XH482eN5:before{content:\"\\E94D\"}._3yvLyGoTOAT9qT:before{content:\"\\E94C\"}._1EwQ2oHkNsiADA:before{content:\"\\E94B\"}.vdBcgQU6hl9lzB:before{content:\"\\E94A\"}._1AbPzXbLiU6DBx:before{content:\"\\E949\"}._1DgL8G7FyUK95B:before{content:\"\\E948\"}.Cx6OtYkXvepdVq:before{content:\"\\E947\"}._3p9lCCWVHR6BSx:before{content:\"\\E946\"}._2rNnr3ETX6mXzD:before{content:\"\\E945\"}._1mBrhlvsvlpwcc:before{content:\"\\E95C\"}.OCwurYbNo7exw-:before{content:\"\\E96A\"}._3hB6G7sWgqEa8J:before{content:\"\\E943\"}._3OYBKwtawjhkpS:before{content:\"\\E942\"}.YAVHR-EsDMUS67:before{content:\"\\E941\"}._17VIYXBt9LbrAX:before{content:\"\\E940\"}.hBOQrhTyYiyWpP:before{content:\"\\E93F\"}.Aq6JvvJzzQG_LS:before{content:\"\\E93E\"}._1IsBDopvw0Ps8G:before{content:\"\\E93D\"}._3xX87war6kiKUx:before{content:\"\\E93C\"}._3O-t8dMdckBYfp:before{content:\"\\E93B\"}._3dyNaHJbcj05xX:before{content:\"\\E93A\"}._1-V4UGOtGJ2onp:before{content:\"\\E939\"}._3q13SK6onKjP88:before{content:\"\\E938\"}._1ZcNOf4L984ydB:before{content:\"\\E937\"}._2CENIFUGJiOGXv:before{content:\"\\E936\"}._2EfyWTDpEkHT61:before{content:\"\\E935\"}._2Pq6e7oDbt-d6z:before{content:\"\\E934\"}._1VuRaE6Dbw2YzY:before{content:\"\\E933\"}._3NYW3XvrmkIoKJ:before{content:\"\\E932\"}._3tgCx0PzFeUBN8:before{content:\"\\E931\"}._3fedpJLJNwVuQm:before{content:\"\\E930\"}._1LZDugQxAR89Bm:before{content:\"\\E92F\"}._1mH50w4lUjz9Fn:before{content:\"\\E92E\"}._3l-yWOxaUhbaGp:before{content:\"\\E92D\"}._2I0xb0lGrBoRrS:before{content:\"\\E92C\"}._2DDU2VVNethndp:before{content:\"\\E92B\"}._3XUwX1WIcXAEC2:before{content:\"\\E92A\"}._1Upx0nDNwFTx5X:before{content:\"\\E929\"}._37OV9KYc0DXzo8:before{content:\"\\E928\"}._2IWAj9kVByUqPJ:before{content:\"\\E927\"}._2syIlSEp6XYRO8:before{content:\"\\E926\"}._3SOVsrsFw0SGE-:before{content:\"\\E925\"}.pFLO1xfZl_Bj7w:before{content:\"\\E924\"}._1Q601QlF9WO1QV:before{content:\"\\E923\"}._2Kj3d5i2Qjr8aG:before{content:\"\\E922\"}._1C3x6uLK1iHji2:before{content:\"\\E921\"}.FSQn-rRezBxRsd:before{content:\"\\E920\"}._3NAjZ7Lb64OgRH:before{content:\"\\E91F\"}._3h89p9a1joW_ZC:before{content:\"\\E91E\"}._2nxa8a6h3qQAUw:before{content:\"\\E91D\"}.JeDac5VAHNAG1E:before{content:\"\\E91C\"}.P7i-lDJAPu15-s:before{content:\"\\E91B\"}.NpUTU5L2vhNGah:before{content:\"\\E91A\"}._3xHzCTg385YiPY:before{content:\"\\E919\"}._273MVfajSysp2O:before{content:\"\\E918\"}._3hW0TjuC6RZfLX:before{content:\"\\E917\"}.zCHe47Sgl8DZ62:before{content:\"\\E96B\"}.Xv4j2oCUS0ERTx:before{content:\"\\E916\"}._2K0KaEjbursXxA:before{content:\"\\E915\"}.zH4gsM1wwvGTmh:before{content:\"\\E914\"}._3ZK2k7fKTF3d4a:before{content:\"\\E913\"}._3fETDcYRfkn87K:before{content:\"\\E912\"}._1uKgl_VMpLwfVL:before{content:\"\\E911\"}.U9-aK52CDjGfeq:before{content:\"\\E910\"}.Pat28bw06E_P32:before{content:\"\\E90F\"}._9u-WgNpJWvbpNP:before{content:\"\\E90E\"}._29g588uvcJXhvA:before{content:\"\\E90D\"}._19mezUfQbuHuUw:before{content:\"\\E90C\"}._38STGU-ixIrOBL:before{content:\"\\E90B\"}._2Gubtp6gwDKNDv:before{content:\"\\E90A\"}._2CpZUG02yRFySt:before{content:\"\\E909\"}._2mT3ANYbKxf-vt:before{content:\"\\E908\"}.s7iPuxr2K-1-AW:before{content:\"\\E907\"}._2vf5pKL-unmT_a:before{content:\"\\E906\"}._2r45eMJlxLajlU:before{content:\"\\E905\"}._-9Kx6TSvjhPQF6:before{content:\"\\E904\"}._1gc0YynY7WvINC:before{content:\"\\E903\"}._2-s0edbBUCZLfs:before{content:\"\\E902\"}.XHBQk9Sh9PAFMV:before{content:\"\\E901\"}._2lskq-tiMh5Cmj:before{content:\"\\E95C\"}._3YlMR-aKPE-6Py{color:#eb5a46}._2wIkDUITn0rQgB{color:#61bd4f}.bq0exRhZzT3mQH{color:#798d99}._3Equ0AwjtQdiIh{color:#fff}._2wTuPX_wSmi5Oi{color:#516b7a}._3y6MSD-EkP17zT{color:#f2d600}._34fwZQzLHT7jnh{color:#0079bf}._3nZZwYm5iLUjZl{color:#c377e0}.kHbjplgB9Uk0aR{color:#ff78cb}._1wOU2f8ttRfB6_{text-align:center;vertical-align:middle}._1wOU2f8ttRfB6_:before{content:\"\";display:inline-block;background-repeat:no-repeat;background-position:50%;background-size:cover}._1wOU2f8ttRfB6_.PFt09HVBG7wMY9:before{width:12px;height:12px}._1wOU2f8ttRfB6_._2KEwvRY1oTHWsQ:before{width:16px;height:16px}._1wOU2f8ttRfB6_.zCHe47Sgl8DZ62:before{background-image:url(" + escape(require("images/icon-member-remove.svg")) + ")}._1wOU2f8ttRfB6_.Amzy_Uos05KXvv:before{background-image:url(" + escape(require("images/icon-copy.svg")) + ")}", ""]);

// exports
exports.locals = {
	"N0": "#FFFFFF",
	"N10": "#FAFCFC",
	"N20": "#F5F6F7",
	"N30": "#EBEEF0",
	"N40": "#DFE3E6",
	"N50": "#C2CCD1",
	"N60": "#B3BEC4",
	"N70": "#A6B3BA",
	"N80": "#97A7B0",
	"N90": "#899AA3",
	"N100": "#798D99",
	"N200": "#6B808C",
	"N300": "#5E7785",
	"N400": "#516B7A",
	"N500": "#425E6E",
	"N600": "#355263",
	"N700": "#254659",
	"N800": "#17394D",
	"N900": "#092D42",
	"N10A": "rgba(9, 45, 66, 0.02)",
	"N20A": "rgba(9, 45, 66, 0.04)",
	"N30A": "rgba(9, 45, 66, 0.08)",
	"N40A": "rgba(9, 45, 66, 0.13)",
	"N50A": "rgba(9, 45, 66, 0.25)",
	"N60A": "rgba(9, 45, 66, 0.31)",
	"N70A": "rgba(9, 45, 66, 0.36)",
	"N80A": "rgba(9, 45, 66, 0.42)",
	"N90A": "rgba(9, 45, 66, 0.48)",
	"N100A": "rgba(9, 45, 66, 0.54)",
	"N200A": "rgba(9, 45, 66, 0.6)",
	"N300A": "rgba(9, 45, 66, 0.66)",
	"N400A": "rgba(9, 45, 66, 0.71)",
	"N500A": "rgba(9, 45, 66, 0.77)",
	"N600A": "rgba(9, 45, 66, 0.82)",
	"N700A": "rgba(9, 45, 66, 0.89)",
	"N800A": "rgba(9, 45, 66, 0.95)",
	"trello-blue-50": "#E4F0F6",
	"trello-blue-100": "#BCD9EA",
	"trello-blue-200": "#8BBDD9",
	"trello-blue-300": "#5BA4CF",
	"trello-blue-400": "#298FCA",
	"trello-blue-500": "#0079BF",
	"trello-blue-600": "#026AA7",
	"trello-blue-700": "#055A8C",
	"trello-blue-800": "#094C72",
	"trello-blue-900": "#0C3953",
	"green-50": "#EEF6EC",
	"green-100": "#D6ECD2",
	"green-200": "#B7DDB0",
	"green-300": "#99D18F",
	"green-400": "#7BC86C",
	"green-500": "#61BD4F",
	"green-600": "#5AAC44",
	"green-700": "#519839",
	"green-800": "#49852E",
	"green-900": "#3F6F21",
	"orange-50": "#FDF4E7",
	"orange-100": "#FCE6C6",
	"orange-200": "#FAD29C",
	"orange-300": "#FDBF69",
	"orange-400": "#FFAF3F",
	"orange-500": "#FF9F1A",
	"orange-600": "#E79217",
	"orange-700": "#CD8313",
	"orange-800": "#B4760F",
	"orange-900": "#96650A",
	"red-50": "#FBEDEB",
	"red-100": "#F5D3CE",
	"red-200": "#EFB3AB",
	"red-300": "#EC9488",
	"red-400": "#EF7564",
	"red-500": "#EB5A46",
	"red-600": "#CF513D",
	"red-700": "#B04632",
	"red-800": "#933B27",
	"red-900": "#6E2F1A",
	"yellow-50": "#FDFAE5",
	"yellow-100": "#FAF3C0",
	"yellow-200": "#F5EA92",
	"yellow-300": "#F3E260",
	"yellow-400": "#F5DD29",
	"yellow-500": "#F2D600",
	"yellow-600": "#E6C60D",
	"yellow-700": "#D9B51C",
	"yellow-800": "#CCA42B",
	"yellow-900": "#BD903C",
	"purple-50": "#F7F0FA",
	"purple-100": "#EDDBF4",
	"purple-200": "#DFC0EB",
	"purple-300": "#D5A6E6",
	"purple-400": "#CD8DE5",
	"purple-500": "#C377E0",
	"purple-600": "#A86CC1",
	"purple-700": "#89609E",
	"purple-800": "#6C547B",
	"purple-900": "#484553",
	"pink-50": "#FEF1F9",
	"pink-100": "#FCDCEF",
	"pink-200": "#F9C2E4",
	"pink-300": "#FFABDF",
	"pink-400": "#FF8ED4",
	"pink-500": "#FF78CB",
	"pink-600": "#E568AF",
	"pink-700": "#C9558F",
	"pink-800": "#AE4270",
	"pink-900": "#8E2D4B",
	"sky-50": "#E4F7FA",
	"sky-100": "#BDECF3",
	"sky-200": "#8FDFEB",
	"sky-300": "#5DD3E5",
	"sky-400": "#29CCE5",
	"sky-500": "#00C2E0",
	"sky-600": "#00AECC",
	"sky-700": "#0098B7",
	"sky-800": "#0082A0",
	"sky-900": "#006988",
	"lime-50": "#ECFBF3",
	"lime-100": "#D3F6E4",
	"lime-200": "#B3F1D0",
	"lime-300": "#90ECC1",
	"lime-400": "#6DECA9",
	"lime-500": "#51E898",
	"lime-600": "#4ED583",
	"lime-700": "#4BBF6B",
	"lime-800": "#49AA54",
	"lime-900": "#459139",
	"business-blue-50": "#EDEFF4",
	"business-blue-100": "#D2D7E5",
	"business-blue-200": "#B2B9D0",
	"business-blue-300": "#838FB5",
	"business-blue-400": "#6170A1",
	"business-blue-500": "#42548E",
	"business-blue-600": "#3E4D80",
	"business-blue-700": "#3A476F",
	"business-blue-900": "#30364C",
	"business-blue-800": "#36405F",
	"blue-500": "#0079BF",
	"black": "#000",
	"black-500": "#4d4d4d",
	"near-black": "#4d4d4d",
	"white": "#FFFFFF",
	"icon": "_2O4TvNuF7v0hxu",
	"icon-lg": "_2KEwvRY1oTHWsQ",
	"icon-sm": "PFt09HVBG7wMY9",
	"icon-activity": "Ti1qtx843DNeij",
	"icon-add": "_2p2TP4mBgXTJP3",
	"icon-add-member": "_1lRR-WGFaAL7Rg",
	"icon-admin-chevron": "sVIW73wwiyo-ks",
	"icon-app-store": "_1OryvMSh-C4bWl",
	"icon-archive": "_1de3r8WsF7Yh8K",
	"icon-atlassian": "_3i67k-gVumomHu",
	"icon-attachment": "_31TAf4mRgtkVX1",
	"icon-back": "_2RhErfMv_mzFHP",
	"icon-board": "_2H2bc6x5IUre2M",
	"icon-box": "_3dQefSBi-fAz7d",
	"icon-browse": "XJAu7LvbAvjSOO",
	"icon-business-class": "_2X44dse6n-cQsb",
	"icon-calendar": "AWpfRMKS6EXBgD",
	"icon-camera": "_2Vf6cuxKtYocO6",
	"icon-card": "bwL1OKx7tRehy-",
	"icon-card-cover": "_3aNdzOPsziq37o",
	"icon-card-recurring": "_3jWf4yaZ1WbIbz",
	"icon-check": "GOq5Er_TVbEM3t",
	"icon-checkbox-checked": "_3bSwJmXnSoGyIF",
	"icon-checkbox-unchecked": "_1ecbMWhcUXKTSA",
	"icon-checklist": "_2aGFP06p1cMlIx",
	"icon-clock": "_2gw3dyIjIZ9sq2",
	"icon-close": "_13OvihIH2x9qPC",
	"icon-collection": "w7LPN0RMWIlifw",
	"icon-comment": "_2LDR5G_PpSxWfb",
	"icon-copy": "Amzy_Uos05KXvv",
	"icon-custom-field": "kj9GoITAoCRkdj",
	"icon-description": "_1iYaKo0RX8H9ru",
	"icon-documents": "_1fL5z3XH482eN5",
	"icon-down": "_3yvLyGoTOAT9qT",
	"icon-download": "_1EwQ2oHkNsiADA",
	"icon-dropbox": "vdBcgQU6hl9lzB",
	"icon-dropdown-menu": "_1AbPzXbLiU6DBx",
	"icon-dropdown-options": "_1DgL8G7FyUK95B",
	"icon-edit": "Cx6OtYkXvepdVq",
	"icon-email": "_3p9lCCWVHR6BSx",
	"icon-emoji": "_2rNnr3ETX6mXzD",
	"icon-enterprise": "_1mBrhlvsvlpwcc",
	"icon-external-link1": "OCwurYbNo7exw-",
	"icon-external-link": "_3hB6G7sWgqEa8J",
	"icon-facebook": "_3OYBKwtawjhkpS",
	"icon-filter": "YAVHR-EsDMUS67",
	"icon-fogbugz": "_17VIYXBt9LbrAX",
	"icon-forward": "hBOQrhTyYiyWpP",
	"icon-gear": "Aq6JvvJzzQG_LS",
	"icon-github": "_1IsBDopvw0Ps8G",
	"icon-google": "_3xX87war6kiKUx",
	"icon-google-drive": "_3O-t8dMdckBYfp",
	"icon-google-share": "_3dyNaHJbcj05xX",
	"icon-heart": "_1-V4UGOtGJ2onp",
	"icon-help": "_3q13SK6onKjP88",
	"icon-home": "_1ZcNOf4L984ydB",
	"icon-house": "_2CENIFUGJiOGXv",
	"icon-image": "_2EfyWTDpEkHT61",
	"icon-information": "_2Pq6e7oDbt-d6z",
	"icon-information-bubble": "_1VuRaE6Dbw2YzY",
	"icon-kiln": "_3NYW3XvrmkIoKJ",
	"icon-label": "_3tgCx0PzFeUBN8",
	"icon-leave-board": "_3fedpJLJNwVuQm",
	"icon-lightbulb": "_1LZDugQxAR89Bm",
	"icon-lightbulb-lit": "_1mH50w4lUjz9Fn",
	"icon-list": "_3l-yWOxaUhbaGp",
	"icon-log-out": "_2I0xb0lGrBoRrS",
	"icon-member": "_2DDU2VVNethndp",
	"icon-mention": "_3XUwX1WIcXAEC2",
	"icon-microphone": "_1Upx0nDNwFTx5X",
	"icon-microphone-off": "_37OV9KYc0DXzo8",
	"icon-move": "_2IWAj9kVByUqPJ",
	"icon-nearby": "_2syIlSEp6XYRO8",
	"icon-notification": "_3SOVsrsFw0SGE-",
	"icon-number": "pFLO1xfZl_Bj7w",
	"icon-onedrive": "_1Q601QlF9WO1QV",
	"icon-open-source": "_2Kj3d5i2Qjr8aG",
	"icon-organization": "_1C3x6uLK1iHji2",
	"icon-organization-visible": "FSQn-rRezBxRsd",
	"icon-overflow-menu-horizontal": "_3NAjZ7Lb64OgRH",
	"icon-overflow-menu-vertical": "_3h89p9a1joW_ZC",
	"icon-password-manager": "_2nxa8a6h3qQAUw",
	"icon-pin": "JeDac5VAHNAG1E",
	"icon-power-up": "P7i-lDJAPu15-s",
	"icon-private": "NpUTU5L2vhNGah",
	"icon-public": "_3xHzCTg385YiPY",
	"icon-refresh": "_273MVfajSysp2O",
	"icon-remove": "_3hW0TjuC6RZfLX",
	"icon-remove-member": "zCHe47Sgl8DZ62",
	"icon-reorder": "Xv4j2oCUS0ERTx",
	"icon-reply": "_2K0KaEjbursXxA",
	"icon-screenshare": "zH4gsM1wwvGTmh",
	"icon-search": "_3ZK2k7fKTF3d4a",
	"icon-selection-mode": "_3fETDcYRfkn87K",
	"icon-send": "_1uKgl_VMpLwfVL",
	"icon-share": "U9-aK52CDjGfeq",
	"icon-star": "Pat28bw06E_P32",
	"icon-starred": "_9u-WgNpJWvbpNP",
	"icon-sticker": "_29g588uvcJXhvA",
	"icon-subscribe": "_19mezUfQbuHuUw",
	"icon-sync": "_38STGU-ixIrOBL",
	"icon-taco": "_2Gubtp6gwDKNDv",
	"icon-text": "_2CpZUG02yRFySt",
	"icon-trash": "_2mT3ANYbKxf-vt",
	"icon-trello-gold": "s7iPuxr2K-1-AW",
	"icon-twitter": "_2vf5pKL-unmT_a",
	"icon-up": "_2r45eMJlxLajlU",
	"icon-video": "_-9Kx6TSvjhPQF6",
	"icon-video-off": "_1gc0YynY7WvINC",
	"icon-vote": "_2-s0edbBUCZLfs",
	"icon-warning": "XHBQk9Sh9PAFMV",
	"icon-enterprise-dashboard": "_2lskq-tiMh5Cmj",
	"icon-red": "_3YlMR-aKPE-6Py",
	"icon-green": "_2wIkDUITn0rQgB",
	"icon-gray": "bq0exRhZzT3mQH",
	"icon-light": "_3Equ0AwjtQdiIh",
	"icon-dark": "_2wTuPX_wSmi5Oi",
	"icon-yellow": "_3y6MSD-EkP17zT",
	"icon-blue": "_34fwZQzLHT7jnh",
	"icon-purple": "_3nZZwYm5iLUjZl",
	"icon-pink": "kHbjplgB9Uk0aR",
	"icon-custom": "_1wOU2f8ttRfB6_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2772/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/controls/icon/icon.less
// module id = LEL2
// module chunks = 13